











































































































































































































import { Component } from "vue-property-decorator";
import ajax from "../../../lib/ajax";
import AbpBase from "../../../lib/abpbase";

interface UpstreamCounters {
  upstreamCount: number;
  cacheHitCount: number;
  singleFlightWaitCount: number;
  singleFlightTimeoutCount: number;
  upstreamTimeoutCount: number;
  upstreamErrorCount: number;
  totalRequestCount: number;
  cacheHitRate: number;
}

interface UpstreamDirection extends UpstreamCounters {
  direction: string;
}

interface UpstreamStatistic extends UpstreamCounters {
  provider: string;
  directions: UpstreamDirection[];
}

interface ApiResponse {
  result: {
    date: string;
    totalUpstream: number;
    totalRequests: number;
    cacheHitRate: number;
    statistics: UpstreamStatistic[];
  };
  success: boolean;
  error: any;
}

@Component({})
export default class ProviderUpstreamStatistics extends AbpBase {
  dateMenu = false;
  selectedDate = new Date().toISOString().substr(0, 10);
  loading = false;
  hasSearched = false;
  statistics: UpstreamStatistic[] = [];
  totalUpstream = 0;
  totalRequests = 0;
  cacheHitRate = 0;
  expandedProviders: UpstreamStatistic[] = [];

  headers = [
    { text: "Sağlayıcı", value: "provider", sortable: true },
    { text: "Toplam İstek", value: "totalRequestCount", sortable: true },
    { text: "Sağlayıcıya Giden", value: "upstreamCount", sortable: true },
    { text: "Cache'ten", value: "cacheHitCount", sortable: true },
    { text: "Bekleyen", value: "singleFlightWaitCount", sortable: true },
    { text: "Cache Oranı", value: "cacheHitRate", sortable: true },
    { text: "Sorunlu Çağrı", value: "problems", sortable: false },
    { text: "", value: "data-table-expand", sortable: false, align: "end" },
  ];

  breadcrumbsItems = [
    {
      text: "Ana Sayfa",
      disabled: false,
      href: "/main/home",
    },
    {
      text: "Sağlayıcıya Giden Sorgular",
      disabled: true,
    },
  ];

  get getFormattedDate() {
    if (!this.selectedDate) return "";
    const date = new Date(this.selectedDate);
    return date.toLocaleDateString("tr-TR");
  }

  getDirectionLabel(direction: string): string {
    if (direction === "OW") return "Tek Yön (OW)";
    if (direction === "RT") return "Gidiş-Dönüş (RT)";
    return direction;
  }

  toggleProvider(item: UpstreamStatistic) {
    const index = this.expandedProviders.findIndex(
      (p) => p.provider === item.provider
    );
    if (index > -1) {
      this.expandedProviders.splice(index, 1);
    } else {
      this.expandedProviders.push(item);
    }
  }

  getRateColor(rate: number): string {
    if (rate >= 90) return "green";
    if (rate >= 70) return "light-green darken-2";
    if (rate >= 40) return "orange";
    return "red";
  }

  async loadStatistics() {
    this.loading = true;
    this.hasSearched = true;

    try {
      const response = await ajax.get<ApiResponse>(
        `/api/services/app/Admin/GetDailyProviderUpstreamStatistics?date=${this.selectedDate}`
      );

      if (response.data.success && response.data.result) {
        // Satır nesneleri değiştiği için eski açık satır referansları geçersiz kalır.
        this.expandedProviders = [];
        this.statistics = response.data.result.statistics || [];
        this.totalUpstream = response.data.result.totalUpstream;
        this.totalRequests = response.data.result.totalRequests;
        this.cacheHitRate = response.data.result.cacheHitRate;
      } else {
        this.resetTotals();
        this.$swal({
          icon: "error",
          title: "Hata",
          text: "Veriler yüklenirken bir hata oluştu",
        });
      }
    } catch (error) {
      this.resetTotals();
      console.error("Error loading upstream statistics:", error);
    } finally {
      this.loading = false;
    }
  }

  resetTotals() {
    this.statistics = [];
    this.totalUpstream = 0;
    this.totalRequests = 0;
    this.cacheHitRate = 0;
    this.expandedProviders = [];
  }

  mounted() {
    this.loadStatistics();
  }
}
